import { FieldInsuredDefault } from '../../enums/fields/field-insured.default';
import { EditableDefaultClaimFields, FieldClaimDefault, overridableEditableClaimFields } from '../../enums/fields/field-claim.default';
import { SmartphotoNotifications } from './smartphoto-notifications.class';
import { FieldInsuredOptional } from '../../enums/fields/field-insured.optional';
export class SmartphotoFields {
    insured;
    claim;
    vehicle;
    constructor(smartphoto, fields, canEditInformation, hasPermissions) {
        // TODO: Enhance smartphoto fields descriptions abstraction, enums are not enough
        const fieldsFilter = FieldInsuredOptional.filter(({ properties: [prop] }) => smartphoto[prop] !== undefined);
        const insuredFields = FieldInsuredDefault.concat(fieldsFilter);
        this.insured = SmartphotoFields.generate(fields.insured, insuredFields).map(({ label, type, properties, editable, custom }) => {
            if (label === 'grade') {
                const feedbackMap = {
                    1: 'bad',
                    6: 'regular',
                    10: 'good'
                };
                return {
                    label: 'feedback',
                    type,
                    properties,
                    options: [],
                    value: feedbackMap[smartphoto.grade]
                };
            }
            if (label === 'next_reminder') {
                const notifications = new SmartphotoNotifications(smartphoto.notifications);
                const nextReminderTimestamp = notifications.nextReminder?.scheduled;
                return {
                    label,
                    type,
                    properties,
                    options: [],
                    value: nextReminderTimestamp ? new Date(nextReminderTimestamp) : undefined
                };
            }
            const value = properties
                .map((property) => smartphoto[property] ?? '')
                .join(' ')
                .trim();
            if (label === 'sender') {
                return {
                    label,
                    type,
                    properties,
                    options: [],
                    value: value === '' ? 'bdeo' : value
                };
            }
            return {
                label,
                type,
                properties,
                options: [],
                value,
                editable: editable === true && properties.length === 1,
                custom
            };
        });
        // TODO: Este fix es temporal, hay que refactorizar el código para tener una solución más robusta
        const defaultClaimFields = [...FieldClaimDefault];
        const agentField = fields.claim.find(({ label }) => label === 'assigned_agent_name');
        if (agentField) {
            defaultClaimFields.push(agentField);
        }
        this.claim = SmartphotoFields.generate(fields.claim, defaultClaimFields).map(({ label, properties, type, editable, custom }) => {
            let value = smartphoto[properties[0]];
            if (properties[0].includes('At') && typeof value === 'number') {
                value *= 1000;
            }
            if (properties.length > 1) {
                value = properties
                    .map((property) => smartphoto[property] ?? undefined)
                    .join(' ')
                    .trim();
            }
            const editableStatuses = EditableDefaultClaimFields[label];
            const isEditableByStatus = editableStatuses === undefined ? true : editableStatuses.includes(smartphoto.status);
            const isOverridableEditable = hasPermissions && (custom || overridableEditableClaimFields.includes(label));
            return {
                label,
                type,
                properties,
                options: [],
                value,
                editable: properties.length === 1 && Boolean(editable) && (isOverridableEditable ? canEditInformation : isEditableByStatus),
                custom
            };
        });
        this.vehicle = SmartphotoFields.generate(fields.vehicle).map(({ label, properties, type, required, custom, editable }) => {
            return {
                label,
                type,
                properties,
                value: properties
                    .map((property) => smartphoto[property] ?? '')
                    .join(' ')
                    .trim(),
                required,
                custom,
                editable
            };
        });
    }
    static generate(fields, defaultFields = []) {
        const base = defaultFields.map((defaultField) => {
            const field = fields.find(({ properties }) => properties.includes(defaultField.properties[0]));
            if (!field) {
                return defaultField;
            }
            return field;
        });
        const fieldsFilters = fields
            .filter(({ label }) => !defaultFields.find(({ label: defaultLabel }) => label === defaultLabel))
            .map((field) => ({ ...field, custom: true }));
        return [...new Set(base), ...fieldsFilters];
    }
}
